import { SHARED_DATA_TYPE } from "@/domain/sharedData/constants"
import { getSharedEntityName } from "@/domain/sharedData/getSharedUtils"
import type { SharedDataJsonldReadCollectionSharedData } from "@/networking/api"
import { Box } from "@chakra-ui/react"
import { useIntl } from "react-intl"

type Props = {
  item: SharedDataJsonldReadCollectionSharedData
  displayInputLike?: boolean
}

export default ({ item, displayInputLike }: Props) => {
  const intl = useIntl()

  const type =
    item?.type?.code === SHARED_DATA_TYPE.PEOPLE
      ? intl.formatMessage({ id: "userSharedData.object_type_people" })
      : item?.type?.code === SHARED_DATA_TYPE.PROJECT
        ? intl.formatMessage({ id: "userSharedData.object_type_project" })
        : item?.type?.code === SHARED_DATA_TYPE.INTER_BU
          ? intl.formatMessage({ id: "userSharedData.object_type_interbu" })
          : intl.formatMessage({ id: "userSharedData.object_type_entity" })

  const name = getSharedEntityName(item)

  return displayInputLike ? (
    <Box
      display="block"
      padding="0.5rem 1rem"
      borderStyle="solid"
      borderWidth="1px"
      borderColor="line"
      color="textSubtle"
      fontSize="small"
    >
      {item?.type?.code === SHARED_DATA_TYPE.PROJECT ? `${type} #${name}` : name}
    </Box>
  ) : item?.type?.code === SHARED_DATA_TYPE.PROJECT ? (
    <>{`${type} #${name}`}</>
  ) : (
    <>{name}</>
  )
}
